// Assembles the final session manifest exactly per HANDOFF schema Section 5.
import { sha256Hex } from '../audio/recorder';

export async function assembleManifest(session, deviceInfo = session.deviceInfo) {
  const textChecksum = session.textTrial ? await sha256Hex(session.textTrial.blob) : null;
  const imageChecksum = session.imageTrial?.blob ? await sha256Hex(session.imageTrial.blob) : null;

  const now = new Date();

  return {
    schema_version: '2.0',
    session_id: session.sessionId,
    participant_id: session.participantId,
    session_number: session.sessionNumber,
    content_index: session.contentIndex,
    day_number: session.dayNumber,
    session_within_day: session.sessionWithinDay,
    start_ts_utc: session.startTsUtc,
    end_ts_utc: now.toISOString(),
    timezone_offset_minutes: -now.getTimezoneOffset(),
    timezone_iana: Intl.DateTimeFormat().resolvedOptions().timeZone,

    device_info: deviceInfo,

    affect_pre: session.affectPre,
    affect_post: session.affectPost,

    text_trial: session.textTrial
      ? {
          trial_id: session.textTrial.trial_id,
          content_key: session.textTrial.content_key,
          passage_text: session.textTrial.passage_text,
          cue_onset_ts_utc: session.textTrial.cue_onset_ts_utc,
          recording_start_ts_utc: session.textTrial.recording_start_ts_utc,
          recording_end_ts_utc: session.textTrial.recording_end_ts_utc,
          duration_ms: session.textTrial.duration_ms,
          audio_file: 'text_audio.webm',
          audio_checksum_sha256: textChecksum,
          audio_size_bytes: session.textTrial.blob?.size ?? 0,
          was_abandoned: false,
        }
      : null,

    image_trial: session.imageTrial
      ? {
          trial_id: session.imageTrial.trial_id,
          content_key: session.imageTrial.content_key,
          image_filename: session.imageTrial.image_filename,
          prompt_text: session.imageTrial.prompt_text,
          cue_onset_ts_utc: session.imageTrial.cue_onset_ts_utc,
          recording_start_ts_utc: session.imageTrial.recording_start_ts_utc,
          recording_end_ts_utc: session.imageTrial.recording_end_ts_utc,
          duration_ms: session.imageTrial.duration_ms,
          audio_file: 'image_audio.webm',
          audio_checksum_sha256: imageChecksum,
          audio_size_bytes: session.imageTrial.blob?.size ?? 0,
          was_abandoned: false,
        }
      : null,

    m2c2_results: session.m2c2Results ?? { battery_complete: false, activities: {} },

    upload_info: {
      upload_ts_utc: null, // filled in by the caller after a successful upload
      upload_attempts: 0,
      upload_method: 'r2_presigned_put',
    },

    session_abandoned: false,
    abandonment_phase: null,
  };
}

export function collectDeviceInfo(audioConstraintsRequested, audioConstraintsActual, mimeType) {
  return {
    user_agent: navigator.userAgent,
    platform: /android/i.test(navigator.userAgent)
      ? 'Android'
      : /iphone|ipad|ipod/i.test(navigator.userAgent)
        ? 'iOS'
        : 'Other',
    pwa_version: import.meta.env.VITE_APP_VERSION ?? '1.0.0',
    audio_mime_type_used: mimeType,
    audio_constraints_requested: audioConstraintsRequested,
    audio_constraints_actual: audioConstraintsActual,
  };
}
